import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContentDesignViewWrapperComponent } from './components/content-design-view-wrapper/content-design-view-wrapper.component';
import { ContentIncludeComponent } from './components/content-include/content-include.component';
import { ContentPageletComponent } from './components/content-pagelet/content-pagelet.component';
import { CMS_COMPONENT } from './configurations/injection-keys';

@NgModule({
  imports: [AsyncPipe, ContentDesignViewWrapperComponent, ContentPageletComponent],
  declarations: [ContentIncludeComponent],
  exports: [ContentIncludeComponent],
  providers: [
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.text.pagelet2-Component',
        loadComponent: () => import('../cms/components/cms-text/cms-text.component').then(m => m.CMSTextComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.freeStyle.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-freestyle/cms-freestyle.component').then(m => m.CMSFreestyleComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.container.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-container/cms-container.component').then(m => m.CMSContainerComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.image.pagelet2-Component',
        loadComponent: () => import('../cms/components/cms-image/cms-image.component').then(m => m.CMSImageComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.imageEnhanced.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-image-enhanced/cms-image-enhanced.component').then(
            m => m.CMSImageEnhancedComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.carousel.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-carousel/cms-carousel.component').then(m => m.CMSCarouselComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.productListManual.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-product-list-manual/cms-product-list-manual.component').then(
            m => m.CMSProductListManualComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.productListFilter.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-product-list-filter/cms-product-list-filter.component').then(
            m => m.CMSProductListFilterComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.productListCategory.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-product-list-category/cms-product-list-category.component').then(
            m => m.CMSProductListCategoryComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.productListRest.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-product-list-rest/cms-product-list-rest.component').then(
            m => m.CMSProductListRestComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.video.pagelet2-Component',
        loadComponent: () => import('../cms/components/cms-video/cms-video.component').then(m => m.CMSVideoComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.shopping.staticPage.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-static-page/cms-static-page.component').then(m => m.CMSStaticPageComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:pagevariant.standard.pagelet2-Pagevariant',
        loadComponent: () =>
          import('../cms/components/cms-standard-page/cms-standard-page.component').then(
            m => m.CMSStandardPageComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.common.dialog.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-dialog/cms-dialog.component').then(m => m.CMSDialogComponent),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.navigation.link.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-navigation-link/cms-navigation-link.component').then(
            m => m.CMSNavigationLinkComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.navigation.page.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-navigation-page/cms-navigation-page.component').then(
            m => m.CMSNavigationPageComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'app_sf_base_cm:component.navigation.category.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-navigation-category/cms-navigation-category.component').then(
            m => m.CMSNavigationCategoryComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'dias_app_sf_pwa_cm:component.common.categoryListManual.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-category-list-manual/cms-category-list-manual.component').then(
            m => m.CMSCategoryListManualComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName:
          'dias_app_sf_pwa_cm:component.system.pwa.quickorder.mainnavigation.link.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-quick-order-navigation-link/cms-quick-order-navigation-link.component').then(
            m => m.CmsQuickOrderNavigationLinkComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'dias_app_sf_pwa_cm:component.system.icsa.mainnavigation.full.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-main-navigation/cms-main-navigation.component').then(
            m => m.CMSMainNavigationComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'dias_app_sf_pwa_cm:component.collection.externallink.pagelet2-Component',
        loadComponent: () =>
          import('../cms/components/cms-main-navigation-link/cms-main-navigation-link.component').then(
            m => m.CmsMainNavigationLinkComponent
          ),
      },
      multi: true,
    },
    {
      provide: CMS_COMPONENT,
      useValue: {
        definitionQualifiedName: 'dias_app_sf_pwa_cm:component.icsa.system.mainnavigation.category.pagelet2-component',
        loadComponent: () =>
          import('../cms/components/cms-main-navigation-category/cms-main-navigation-category.component').then(
            m => m.CMSMainNavigationCategoryComponent
          ),
      },
      multi: true,
    },
  ],
})
export class CMSModule {}
